import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SvgIconComponent } from '~/shared/form-elements/components/svg-icon/svg-icon.component';
import { ClickKeydownEnterSpaceDirective } from '~/shared/directives/clickKeyDownEnterSpace.directive';

@Component({
  selector: 'qvs-registration-error',
  standalone: true,
  imports: [CommonModule, IonicModule, SvgIconComponent, ClickKeydownEnterSpaceDirective],
  templateUrl: './registration-error.component.html',
  styleUrls: ['./registration-error.component.scss']
})
export class RegistrationErrorComponent {
  @Input() title = '';
  @Input() paragraphOne = '';
  @Input() paragraphTwo = '';
  @Input() supportMail = '';
  @Input() supportPhone = '';
  @Input() buttonText = '';
  @Input() disableBackground = false;
  @Input() isButtonDisabled = false;

  @Output() buttonClick = new EventEmitter<void>();
}
